<template>
    <section class="hero is-flex main" v-if="fetchMyProfile">
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

        <div class="bg-icon icon-2"><img src="../assets/images/stars.png" alt=""></div>
        <div class="title is-capitalized">profile</div>
        <div class="container">
            <div class="bg-icon icon-1"><img src="../assets/images/rainbow3.png" alt=""></div>
            <div class="card profile">
                <b-modal  
                :active.sync="profileModalActive"
                has-modal-card
                trap-focus
                :destroy-on-hide="true"
                aria-role="dialog"
                aria-modal>
                  <set-profile @over="profileModalActive = false"></set-profile>
                </b-modal>
                <div class="card-content">
                    <div class="profile-details">
                        <div class="profile-img">
                            <b-image rounded :src="(fetchMyProfile.profile_picture) ? fetchMyProfile.profile_picture : require('@/assets/images/no-avatar.webp')"></b-image>
                        </div>
                        <div class="container">
                            <div class="subtitle">{{fetchMyProfile.name}}</div>
                            <div class="columns">
                                <div class="column left">
                                    <p>Mobile Number :</p>
                                    <p>Email Address :</p>
                                    <p>Number of kids :</p>
                                </div>
                                <div class="column right">
                                    <p>{{fetchMyProfile.mobile}}</p>
                                    <p>{{fetchMyProfile.email}}</p>
                                    <p>{{fetchMyProfile.no_kids}} kids</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="button" @click="profileModalActive = true">
                        <span><img src="../assets/images/edit-icon.svg" alt=""></span>
                        <span >edit profile</span>
                    </div>
                </div>
            </div>
            <div class="tab-container">
                <div class="tabs">
                    <ul>
                        <li class="active">
                            <a>
                                <span>Kid 1</span>
                            </a>
                        </li>
                        <li>
                            <a>
                                <span>Kid 2</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="input-container">
                        <span class="icon"><img src="../assets/images/user2.svg" alt=""></span>
                        <input type="text" name="fullname" id="" placeholder="Full Name">
                    </div>
                    <div class="input-container">
                        <span class="icon"><img src="../assets/images/calendar.svg" alt=""></span>
                        <input type="text" name="fullname" id="" placeholder="Date of Birth">
                    </div>
                    <div class="button">update</div>
                </div>
            </div>
        </div>
    </section>
  </template>
  <script>
  //Vuex
  import { mapGetters, mapActions } from "vuex";
  // import EmptyTable from '@/components/EmptyTable'
//   import PageTitle from "@/components/PageTitle";
  import SetProfile from "@/components/Profile/SetProfile";
//   import SetKid from "@/components/Kid/SetKid";
  
  export default {
    name: "Profile",
    components: {
    //   PageTitle,
      SetProfile,
    //   SetKid
      // EmptyTable
    },
    data() {
      return {
        isLoading: false,
        profileModalActive : false,
        current_tab_index : 0
      }
    },
    computed: {
      ...mapGetters(["getTeacherToken", "fetchMyProfile"]),
      currentKidId(){
        let id = null
        if(this.fetchMyProfile.kids.length){
          id = this.fetchMyProfile.kids[this.current_tab_index] ? this.fetchMyProfile.kids[this.current_tab_index] : null
        }
        return id
      }
    },
    methods: {
      ...mapActions(["createQuizMaster", "createCandidate", "loadProfile"]),
      
    },
    async created() {
      this.isLoading = true
      await this.loadProfile({ token : this.getTeacherToken })
      this.isLoading = false
    },
  };
  </script>
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
/* bulma css cdn */
@import "https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Source Sans Pro";
  color: #000;
}
body {
  min-height: 100vh;
  width: 100%;
}

.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}

.logo-container {
  margin-left: 7vw;
}

.logo-container img {
  width: 6vw;
}

.main {
  align-items: center;
  margin: 6.76vw 4.4vw;
  position: relative;
  gap: 2.4vw;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
  .title{
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
}

@media screen and (max-width: 467px){
  .title{
    font-size: 5vw !important;
  }
}
  .bg-icon {
    position: absolute;
  }
  
  .icon-1 {
    top: -23%;
    left: 62%;
    z-index: 10;
    max-width: 15vw;
  }
  
  .icon-2 {
    top: -3%;
    right: 65%;
    max-width: 5vw;
  }
  
  .main {
    align-items: center;
    margin: 6.76vw 4.4vw;
    position: relative;
  }
  .main .container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5vw;
    width: 100%;
  }
  .main .container .profile {
    background: linear-gradient(88.56deg, rgba(137, 25, 231, 0.1) -0.78%, rgba(49, 199, 255, 0.1) 88.76%);
    box-shadow: none;
    border-radius: 2vw;
  }
  .main .container .profile .card-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 2.2vw 4.4vw;
  }
  .main .container .profile .card-content .profile-details {
    display: flex;
    gap: 4.2vw;
  }
  .main .container .profile .card-content .profile-details .profile-img {
    display: flex;
    aspect-ratio: 1;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    padding: 1.24vw;
    background: #d9d9d9;
    max-height: 21vw;
  }
  .main .container .profile .card-content .profile-details .profile-img img {
    border-radius: 50%;
  }
  .main .container .profile .card-content .profile-details .container {
    display: flex;
    flex-direction: column;
    gap: 0;
    justify-content: center;
  }
  .main .container .profile .card-content .profile-details .container .subtitle {
    font-weight: 600;
    font-size: 2.5vw;
    color: #8919e7;
    margin-bottom: 2vw;
  }
  .main .container .profile .card-content .profile-details .container .columns {
    gap: 3.5vw;
  }
  .main .container .profile .card-content .profile-details .container .columns .left,
  .main .container .profile .card-content .profile-details .container .columns .right {
    font-weight: 600;
    font-size: 1.5vw;
    color: #000000;
    display: flex;
    flex-direction: column;
    gap: 1.5vw;
  }
  .main .container .profile .card-content .profile-details .container .columns .right {
    font-weight: 400;
    color: #5e5e5e;
  }
  .main .container .profile .card-content .button {
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin: 2vw 0;
    padding: 1vw 2vw;
    background: none;
    border: 1px solid #8919e7;
    border-radius: 0.8vw;
    gap: 1vw;
    font-size: 1.7vw;
    text-transform: capitalize;
  }
  .main .container .profile .card-content .button span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main .container .tab-container {
    gap: 0;
  }
  
  .tabs {
    width: 100%;
    width: 100%;
    margin: 0 0 0 3vw !important;
  }
  .tabs ul {
    border: 1px solid #8919e7;
    border-radius: 4vw 4vw 0px 0px;
    justify-content: center;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    flex-shrink: 1;
    max-width: 43vw;
    background: #fff;
  }
  .tabs li.active {
    background: #8919e7;
    border-radius: 3.5vw 3.5vw 0px 0px;
  }
  .tabs li.active a span {
    color: #fff !important;
  }
  .tabs li {
    all: unset;
    width: 100%;
    max-width: 50%;
  }
  .tabs li a {
    padding: 1vw;
    font-size: 1.5vw;
  }
  
  .tab-content {
    background: #f9f9f9;
    border-radius: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3vw 4vw 5vw;
    gap: 3vw;
  }
  .tab-content .input-container {
    background: #ffffff;
    border: 1px solid #c2c2c2;
    border-radius: 1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1vw;
    padding: 1vw;
    flex: 1;
  }
  .tab-content .input-container .icon {
    max-width: 1.5vw;
  }
  .tab-content .input-container input {
    all: unset;
    display: flex;
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #8b8b8b;
  }
  .tab-content .button {
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    color: #fff;
    padding: 1vw 3vw;
    height: 100%;
  }
  
  @media screen and (max-width: 767px) {
    .main .container {
      gap: 7vw;
    }
    .columns {
      display: flex;
      flex-direction: row !important;
    }
    .title {
      font-size: 6vw !important;
      margin-bottom: 3vw !important;
    }
    .card-content {
      flex-direction: column !important;
      align-items: center !important;
      gap: 3vw !important;
    }
    .profile-details {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .profile-details .profile-img {
      max-height: 25vw !important;
    }
    .profile-details .subtitle {
      font-size: 4vw !important;
      display: flex;
      justify-content: center;
    }
    .left,
  .right {
      font-size: 2.5vw !important;
    }
    .button {
      font-size: 2.5vw !important;
      padding: 3vw 3vw !important;
    }
    .button span img {
      max-height: 4vw;
    }
    .tabs li a {
      font-size: 3vw;
    }
    .tab-content {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .tab-content .button {
      height: 0;
    }
    .tab-content .input-container {
      border-radius: 1.5vw;
    }
    .tab-content .input-container input {
      font-size: 2vw;
    }
    .tab-content .input-container .icon {
      max-width: 2vw;
    }
    .icon-1 {
      top: -9%;
      left: 73%;
      z-index: 10;
      max-width: 15vw;
    }
    .icon-2 {
      top: -1%;
      right: 70%;
      max-width: 7vw;
    }
  }
  @media screen and (max-width: 567px) {
    .input-container {
      border-radius: 1.8vw !important;
      padding: 1vw 2vw !important;
    }
    .input-container input {
      font-size: 3vw !important;
    }
    .input-container .icon {
      max-width: 3vw;
    }
  }/*# sourceMappingURL=profile.css.map */
  </style>